import * as React from 'react';
import styled from 'styled-components';
import { DefaultText } from '../../styles/global/css/GlobalText';
import { BorderColor, PastelPrimaryColor, PrimaryColor } from '../../styles/global/css/Utils';

const Row = styled.div`
    ${DefaultText}
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    padding-left: 14px;
    cursor: pointer;
    border-top: 1px solid ${BorderColor};
    border-bottom: 1px solid ${BorderColor};
    margin: auto auto -1px auto;

    &[data-active] {
        background-color: ${PastelPrimaryColor};
        color: ${PrimaryColor};
    }
`;

export default function ListPicker(props: {
	selected: boolean
	onSelect?: () => void
	value: string | JSX.Element
}): JSX.Element {
	return <Row data-active={props.selected || undefined} onClick={() => props.onSelect?.()}>
		{props.value}
	</Row>;
}
